import { COMPANY_TYPE } from './Enums';

export const getDefaultProductTypeForCompany = (companyType) =>
  Number(companyType) === COMPANY_TYPE.RETAIL ? 'RETAIL' : 'DEFINED';

// Las referencias de insumos y preparaciones pertenecen a Food Service. Un
// producto Retail no las usa y su modal de detalle no debe consultar esa API.
export const shouldLoadFoodProductReferences = (companyType, productType) =>
  Number(companyType) !== COMPANY_TYPE.RETAIL && productType !== 'RETAIL';
